module.exports = __webpack_public_path__ + "img/plus-icon.35a2bf51.svg";